module.exports = __webpack_public_path__ + "static/media/Zamora-Drywall-Inc (20).f76345e0.jpg";